import { useEffect, useState } from 'react'
import { BREAKPOINT_LG, BREAKPOINT_MD, BREAKPOINT_SM } from '@constants'

export default function useBreakpointOld() {
  const mqls = [
    // small screen
    window.matchMedia(BREAKPOINT_SM),
    // medium screen
    window.matchMedia(BREAKPOINT_MD),
    // large screen
    window.matchMedia(BREAKPOINT_LG),
  ]

  const [isSmallScreen, setIsSmallScreen] = useState(false)
  const [isMediumScreen, setIsMediumScreen] = useState(false)
  const [isLargeScreen, setIsLargeScreen] = useState(false)

  useEffect(() => {
    const [small, medium, large] = mqls
    const handleBreakpointChange = () => {
      setIsSmallScreen(small.matches)
      setIsMediumScreen(medium.matches)
      setIsLargeScreen(large.matches)
    }

    mqls.forEach((m) => m.addEventListener('change', handleBreakpointChange))
    handleBreakpointChange()

    return () => {
      mqls.forEach((m) => m.removeEventListener('change', handleBreakpointChange))
    }
  }, [])

  return { isSmallScreen, isMediumScreen, isLargeScreen }
}
